/*
  schema_sha256: 935843ba7e754cb3cd92d3e9aca8fc5313aefb0dd38feca8ea357a5e9b94b9ac
  zoolander_commit: 75367c3cfbc7f64e8f660a1559de1410f628d130

  DO NOT MANAULLY MODIFY THIS FILE
  This file is auto generated by: frontend/data-v2/generate_schema.sh
*/ const CURRENT_PINNED_VERSION = '2025-04-14-17.internal';
export default CURRENT_PINNED_VERSION;
export const VERIFICATION_MODE = false;

//# sourceMappingURL=version.js.map